import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, FileUp, XCircle } from "lucide-react";
import { api, fmtApiError } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function SubirMovil() {
  const { token } = useParams();
  const inputRef = useRef(null);
  const [info, setInfo] = useState(undefined); // undefined = verificando, null = inválido
  const [estado, setEstado] = useState("listo"); // listo | enviando | enviado
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/kiosco/qr-info/${token}`).then((r) => setInfo(r.data)).catch(() => setInfo(null));
  }, [token]);

  const subir = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setEstado("enviando");
    setError("");
    try {
      const fd = new FormData();
      fd.append("archivo", file);
      await api.post(`/kiosco/subir-movil/${token}`, fd);
      setEstado("enviado");
    } catch (err) {
      setError(fmtApiError(err));
      setEstado("listo");
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-6" data-testid="pagina-subir-movil">
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-sm rounded-3xl border border-border bg-card p-7 text-center"
      >
        <div className="mb-6 flex justify-center">
          <Logo size={32} />
        </div>
        {info === undefined && <p className="text-sm text-muted-foreground">Verificando el link…</p>}
        {info === null && (
          <div data-testid="subir-invalido">
            <XCircle size={44} className="mx-auto mb-3 text-destructive" />
            <h1 className="text-lg font-bold text-foreground">Link vencido o ya usado</h1>
            <p className="mt-2 text-sm text-muted-foreground">Generá un código nuevo desde el kiosco del local.</p>
          </div>
        )}
        {info && estado !== "enviado" && (
          <div data-testid="subir-form">
            <h1 className="text-lg font-bold text-foreground">Subí tu comprobante</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Para <span className="font-semibold text-primary">{info.empleado}</span> (legajo {info.legajo}).
              Vale una foto del papel o un PDF.
            </p>
            <input
              ref={inputRef}
              type="file"
              accept="image/*,application/pdf"
              capture="environment"
              onChange={subir}
              className="hidden"
              data-testid="input-archivo-movil"
            />
            <button
              onClick={() => inputRef.current?.click()}
              disabled={estado === "enviando"}
              className="mt-6 flex w-full items-center justify-center gap-2 rounded-2xl bg-primary px-4 py-4 text-base font-bold text-primary-foreground transition-all hover:brightness-110 active:scale-[0.98] disabled:opacity-60"
              data-testid="boton-elegir-archivo"
            >
              <FileUp size={20} /> {estado === "enviando" ? "Subiendo…" : "Elegir archivo"}
            </button>
            {error && <p className="mt-3 text-sm text-destructive" data-testid="subir-error">{error}</p>}
          </div>
        )}
        {info && estado === "enviado" && (
          <div data-testid="subir-exito">
            <CheckCircle2 size={48} className="mx-auto mb-3 text-primary" />
            <h1 className="text-lg font-bold text-foreground">Comprobante enviado</h1>
            <p className="mt-2 text-sm text-muted-foreground">El kiosco ya lo recibió. Podés cerrar esta página.</p>
          </div>
        )}
      </motion.div>
    </div>
  );
}
